var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":_vm.$t('stats.interactions')}},[_c('app-echart-bar',{staticStyle:{"width":"100%"},attrs:{"option-data":_vm.option}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }